import { useCallback, useEffect, useRef, useState } from 'react'

// 録音の経過秒。共有 engine は時間を持たないので、録音に入った時刻から数える (一時停止は無い)。
//   elapsed:  画面に出す秒 (1 秒ごとに進む)
//   duration: 送る秒。止めた時刻で凍るので、送信に失敗して再送しても同じ秒数になる
export const useRecordingClock = (recording: boolean) => {
  const startedAt = useRef<number | null>(null)
  const stoppedAt = useRef<number | null>(null)
  const [elapsed, setElapsed] = useState(0)

  const duration = useCallback((): number => {
    if (startedAt.current === null) return 0
    const end = stoppedAt.current ?? Date.now()
    return Math.max(0, Math.round((end - startedAt.current) / 1000))
  }, [])

  useEffect(() => {
    if (!recording) {
      if (startedAt.current !== null && stoppedAt.current === null) {
        stoppedAt.current = Date.now()
      }
      return
    }
    startedAt.current = Date.now()
    stoppedAt.current = null
    const t = window.setInterval(() => setElapsed(duration()), 1000)
    return () => window.clearInterval(t)
  }, [recording, duration])

  return { elapsed, duration }
}
